// The player's settings: sound volume, how fast looking around turns, and
// whether up and down are swapped. Saved to localStorage when the page is
// allowed to, and fine without it.

export interface Settings {
  /** 0 (off) .. 1. */
  volume: number;
  /** Multiplies mouse and touch look speed: 0.4 .. 2.5. */
  lookSpeed: number;
  invertY: boolean;
}

export const DEFAULT_SETTINGS: Settings = { volume: 0.8, lookSpeed: 1, invertY: false };
export const LOOK_SPEED_RANGE: [number, number] = [0.4, 2.5];
export const SETTINGS_KEY = "orderup.settings";
/** Where settings were saved when the game was Odd Jobs. */
const OLD_SETTINGS_KEY = "oddjobs.settings";

export function parseSettings(raw: unknown): Settings {
  const o = (raw && typeof raw === "object" ? raw : {}) as Record<string, unknown>;
  const num = (v: unknown, min: number, max: number, fallback: number) =>
    typeof v === "number" && Number.isFinite(v) ? Math.max(min, Math.min(max, v)) : fallback;
  return {
    volume: num(o.volume, 0, 1, DEFAULT_SETTINGS.volume),
    lookSpeed: num(o.lookSpeed, ...LOOK_SPEED_RANGE, DEFAULT_SETTINGS.lookSpeed),
    invertY: typeof o.invertY === "boolean" ? o.invertY : DEFAULT_SETTINGS.invertY,
  };
}

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY) ?? localStorage.getItem(OLD_SETTINGS_KEY);
    return raw ? parseSettings(JSON.parse(raw)) : DEFAULT_SETTINGS;
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function saveSettings(s: Settings): void {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(s));
  } catch {
    // Storage blocked: the settings last the session.
  }
}
